import { genericElementToFormData, onDelegatedClick, setLoading, viewTransition } from '../functions.js';

export default class InlineFormElement extends HTMLElement {

    _args = {};
    _isEditing = false;
    _currentValue = null;
    _viewElement = null;
    _editElement = null;
    _triggerElement = null;

    constructor() {
        super();
        
        this._args = Object.assign({}, this.dataset);

        this._viewElement = this.querySelector('inline-form-view');
        this._editElement = this.querySelector('inline-form-editor');
        this._triggerElement = this.querySelector('inline-form-trigger');

        this._editElement.style.display = 'none';
    }
    connectedCallback() {
        this._bindEvents();
        this.classList.add('inlineform--view');
    }

    _getMinRows() {
        let matches = this._currentValue.match(/\n/g);
        if (matches) {
            return matches.length + 2;
        } else {
            return 3;
        }
    }

    _bindEvents() {

        this._bindTriggerEvent();

        this.addEventListener('keydown', event => {
            if (this._isEditing) {
                if (event.key === 'Escape') {
                    this._hideEditor(this._currentValue);
                }
                if (event.key === 'Enter' && (event.ctrlKey || event.metaKey)) {
                    this._save();
                }
            
            }
        });
        
        onDelegatedClick(this, 'button.js-cancel', e => {
            this._hideEditor(this._currentValue);
        });
        onDelegatedClick(this, 'button.js-save', e => {
            this._save();
        });
    }

    _bindTriggerEvent() {
        if (this._triggerElement) {
            this._triggerElement.addEventListener('click', e => {
                e.preventDefault();
                this._showEditor();
            });
        } else {
            this.addEventListener('dblclick', e => {
                e.preventDefault();
                this._showEditor();
            });
        }
    }

    _hideEditor(value) {
        this._isEditing = false;
        this.classList.add('inlineform--view');
        this.classList.remove('inlineform--edit');

        this._viewElement.textContent = value;

        this._editElement.style.display = 'none';
        this._viewElement.style.display = '';
        this._triggerElement.style.display = '';
    }

    _save() {

        let formData = genericElementToFormData(this);
        formData.append('_csrfToken', window.CSRF_TOKEN);
        setLoading(this, true);

        fetch(this.getAttribute('url'), {
            method: 'POST',
            body: formData,
        })
        .then(res => res.json())
        .then(res => {
            setLoading(this, false);

            if (res.result === 1)  {
                this._hideEditor(res.value);
            } else {
                alert(res.msg);
            }

        }).catch(err => {
            setLoading(this, false);
            console.error(err);
        });

    }

    _showEditor() {
        if (this._isEditing) { 
            return; 
        }

        this._isEditing = true;
        this.classList.add('inlineform--edit');
        this.classList.remove('inlineform--view');
        
        this._currentValue = this._viewElement.textContent;

        let type = this.getAttribute('type');

        this._editorElement = this.querySelector('inline-form-editor');

        if (type === 'text') {
            this._editElement.innerHTML = TEXT_TEMPLATE + ACTIONS_TEMPLATE;
        } else {
            this._editElement.innerHTML = TEXTAREA_TEMPLATE + ACTIONS_TEMPLATE;
        }

        let inputOrTextareaElement = this._editElement.querySelector('input,textarea');
        inputOrTextareaElement.value = this._currentValue;
        inputOrTextareaElement.name = this._args.fieldname;
        inputOrTextareaElement.rows = this._getMinRows();

        this._viewElement.style.display = 'none';
        this._triggerElement.style.display = 'none';
        this._editElement.style.display = 'block';

        console.log(this._editElement);

        inputOrTextareaElement.focus();
    }

};

const TEXT_TEMPLATE = `<input type="text" class="form-control mb-2" />`;
const TEXTAREA_TEMPLATE = `<textarea class="form-control mb-2"></textarea>`;

const ACTIONS_TEMPLATE = `<div class="text-end">
                            <button class="btn btn-link btn-sm text-danger js-cancel">Cancel</button>
                            or
                            &nbsp;
                            &nbsp;
                            <button class="btn btn-primary btn-sm js-save">Save</button>
                        </div>`

window.customElements.define('inline-form', InlineFormElement);